import React from 'react';

import { MenuItem, useMediaQuery, useTheme } from '@material-ui/core';

import { ButtonAction } from '../../ui/ui-breadcrumb-header';
import { UiButton } from '../../ui/ui-button';
import { UiKebabMenu } from '../../ui/ui-kebab-menu';

import { ICON_NAMES, MaterialDesignIcon } from '../../util/material-design-icons';

type InputProps = {
  recipientName: string;
  sublabel?: string;
  onClose: () => void;
  handleRecipientNameClick?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void;
  HeaderAction?: ButtonAction;
};

export const MessageThreadHeader = (props: InputProps) => {
  const { recipientName, sublabel, onClose, handleRecipientNameClick, HeaderAction } = props;

  const theme = useTheme();
  const isOnMobile = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <div className="u-display-flex u-justifyContent-spaceBetween u-alignItems-center u-padding">
      <div className="u-display-flex u-alignItems-center">
        {isOnMobile && (
          <MaterialDesignIcon
            iconName={ICON_NAMES.KEYBOARD_ARROW_LEFT}
            className="u-margin-right"
            onClick={onClose}
          />
        )}
        <div>
          <div
            role="presentation"
            className={`typo-h5 u-color-primary ${
              handleRecipientNameClick ? 'u-cursor-pointer u-colorHover-primaryHighlight' : ''
            }`}
            onClick={handleRecipientNameClick}
          >
            {recipientName}
          </div>
          {sublabel ? <div className="typo-subtitle u-color-black">{sublabel}</div> : null}
        </div>
      </div>
      {HeaderAction ? (
        isOnMobile ? (
          <UiKebabMenu menuId="header-kebab-menu">
            <MenuItem onClick={HeaderAction.handler}>{HeaderAction.name}</MenuItem>
          </UiKebabMenu>
        ) : (
          <UiButton
            size="sm"
            variant="tertiary"
            onClick={HeaderAction.handler}
            className="u-margin-right-lg"
          >
            {HeaderAction.Icon || null}
            {HeaderAction.name}
          </UiButton>
        )
      ) : null}
    </div>
  );
};
